export default "__VITE_ASSET__CseweP6$__"